import { put, select, takeLatest } from 'redux-saga/effects'
import { getNotificationCenterSelector } from '../selectors'
import { NotificationCenterConstants } from '../store/notificationCenter.constants'
import { setNotifications, setReadFlagIds } from '../store/notificationCenter.actions'
import { IMarkNotificationReadPayload, INotificationListItem } from '../store/notificationCenter.types'
import LocalStorageService from '../../../services/localStorage.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getUserSelector } from '../../user/selectors'
import Logger from '../../../services/logger.service'

function* markNotificationRead(action: IMarkNotificationReadPayload) {
  const { items, readFlagIds } = yield select(getNotificationCenterSelector)
  const flagId = action.id
  if (flagId == null) return

  const nextReadFlagIds = readFlagIds.includes(flagId) ? readFlagIds : [...readFlagIds, flagId]

  yield put(setReadFlagIds(nextReadFlagIds))
  yield put(
    setNotifications(
      items.map((item: INotificationListItem) => ({
        ...item,
        isRead: nextReadFlagIds.includes(item.id),
      }))
    )
  )

  const { userId, databaseUserName } = yield select(getUserSelector)
  try {
    LocalStorageService.setItemForUserIdAndCleanDatabaseUserName(
      userId,
      databaseUserName,
      'readFlagIds',
      JSON.stringify(nextReadFlagIds)
    )
  } catch (e: any) {
    Logger.error(
      `Notification Center: markNotificationRead - failed to persist readFlagIds to localStorage: ${e?.message}`
    )
  }
}

export function* markNotificationReadSaga() {
  yield takeLatest(NotificationCenterConstants.MARK_NOTIFICATION_READ, performWithMutexHOG, markNotificationRead)
}
